import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { P1 } from '../../../components/Typographies/Paragraph';
import { H3 } from '../../../components/Typographies/Title';
import ImageLine from '../../../images/illustrations/line-2.svg';
import ImageExcursion from '../../../images/illustrations/travel-bag-1x.webp';
import ImageExcursion2x from '../../../images/illustrations/travel-bag-2x.webp';
import ImageExcursion3x from '../../../images/illustrations/travel-bag-3x.webp';
import messages from '../messages';
import NewsletterForm from './NewsletterForm';

const Container = styled.div`
  ${tw`relative flex flex-col-reverse px-medium2 py-big bg-secondary-400 text-white rounded-30 items-center
    md:flex-row md:px-huge2 md:py-0 md:my-big
  `}
  gap:var(--size-big);

  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: 4fr 3fr;
  }
`;

const Description = styled.div`
  ${tw`flex flex-col justify-center w-full md:my-big`}
  gap:var(--size-small);
  z-index: 1;
`;

const Title = styled(H3)`
  .highlight {
    ${tw`text-green-500`}
  }
`;

const Image = styled.img`
  ${tw`w-full`}

  @media (min-width: 768px) {
    order: 1;
  }
`;

const Line = styled.img`
  ${tw`hidden md:block md:absolute`}
  transform: rotateY(175deg);
  bottom: 0;
  z-index: 0;
  width: 58%;
  left: 20px;
}
`;

const NewsletterView = () => (
  <Container>
    <Line alt="Green line" src={ImageLine} />

    <Image
      alt="Picture of a travel bag "
      src={ImageExcursion3x}
      srcSet={`
      ${ImageExcursion} 1x,
      ${ImageExcursion2x} 2x,
      ${ImageExcursion3x} 3x
    `}
    />
    <Description>
      <Title>
        <FormattedHTMLMessage {...messages.title} />
      </Title>
      <P1>
        <FormattedMessage {...messages.description} />
      </P1>

      <NewsletterForm
        buttonId="submitNewsletter"
        inputId="newsletterEmail"
        inputPlaceholder="mike.horn@gmail.com"
      />
    </Description>
  </Container>
);

export default NewsletterView;
